(function () {
  let isLoading = false;

  function init(root) {
    root.querySelectorAll(".product-group__item:not(.is-active)").forEach((a) => {
      a.addEventListener("click", handleClick);
    });
  }

  function reinitSection(newSection, sectionId) {
    if (window.theme && theme.sections) {
      var oldInstance = theme.sections._findInstance(sectionId);
      if (oldInstance) {
        if (typeof oldInstance.onUnload === "function") {
          oldInstance.onUnload();
        }
        theme.sections._removeInstance(sectionId);
      }

      if (theme.Product) {
        theme.sections.register("product", theme.Product, newSection);
      }
    }

    if (window.theme && theme.collapsibles) {
      theme.collapsibles.init(newSection);
    }

    if (window.theme && typeof theme.videoModal === "function") {
      theme.videoModal();
    }

    if (window.AOS) {
      AOS.refreshHard();
    }

    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    init(newSection);
  }

  async function swapSection(url, sectionId, historyUrl) {
    const shopifySection = document.querySelector("#shopify-section-" + sectionId);
    if (!shopifySection) return;

    shopifySection.style.opacity = "0.5";

    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.status);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      // Shopify wraps section response in <div id="shopify-section-{id}">
      const newSection =
        doc.querySelector("#shopify-section-" + sectionId) ||
        doc.body.firstElementChild;

      if (newSection) {
        shopifySection.replaceWith(newSection);
        if (historyUrl) {
          history.pushState({}, "", historyUrl);
        }
        reinitSection(newSection, sectionId);
      } else {
        shopifySection.style.opacity = "";
      }
    } catch (err) {
      console.error("[product-group]", err);
      shopifySection.style.opacity = "";
    }
  }

  async function handleClick(e) {
    e.preventDefault();
    if (isLoading) return;

    const link = e.currentTarget;
    const handle = link.dataset.productHandle;
    const variantId = link.dataset.variantId;
    const wrapper = link.closest("[data-section-id]");
    const sectionId = wrapper?.dataset.sectionId;

    if (!sectionId) return;

    isLoading = true;

    const labelEl = wrapper.querySelector("[data-product-group-label]");
    if (labelEl && link.dataset.groupLabel) {
      labelEl.textContent = link.dataset.groupLabel;
    }

    try {
      const url = "/products/" + handle + "?variant=" + variantId + "&section_id=" + sectionId;
      await swapSection(url, sectionId, "/products/" + handle + "?variant=" + variantId);
    } finally {
      isLoading = false;
    }
  }

  window.addEventListener("popstate", async function () {
    const sectionId =
      document.querySelector(".product-group[data-section-id]")?.dataset.sectionId ||
      document.querySelector("[data-section-type='product'][data-section-id]")?.dataset.sectionId;

    if (!sectionId) return;
    const handle = location.pathname.split("/products/")[1];
    if (!handle || isLoading) return;

    isLoading = true;

    try {
      const search = location.search || "";
      const url =
        "/products/" +
        handle +
        (search ? search + "&" : "?") +
        "section_id=" +
        sectionId;
      await swapSection(url, sectionId);
    } finally {
      isLoading = false;
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });
})();
